function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-2{fill-rule:evenodd;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M40.062,36.851c-8.844,0-16.039-7.195-16.039-16.04S31.218,4.772,40.062,4.772s16.04,7.195,16.04,16.039-7.195,16.04-16.04,16.04ZM40.062,9.413c-6.286,0-11.399,5.114-11.399,11.399s5.114,11.399,11.399,11.399,11.399-5.114,11.399-11.399-5.114-11.399-11.399-11.399Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M22.203,75.228c-6.322,0-11.466-5.144-11.466-11.466v-2.295c0-11.366,9.247-20.613,20.612-20.613h17.3c11.366,0,20.612,9.247,20.612,20.613v2.295c0,6.323-5.144,11.466-11.466,11.466H22.203ZM31.35,45.495c-8.807,0-15.973,7.165-15.973,15.972v2.295c0,3.764,3.062,6.826,6.826,6.826h35.593c3.764,0,6.826-3.062,6.826-6.826v-2.295c0-8.807-7.166-15.972-15.973-15.972h-17.3Z"
});

var SvgNavUser02 = function SvgNavUser02(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNavUser02, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nav_user02.54967ae5.svg";
export { ForwardRef as ReactComponent };